import Axios from "axios";
import {
  SET_LC_SHIPPING_METHOD_LIST,
  UNSET_LC_SHIPPING_METHOD_LIST,
} from "@/store/mutation-types";
import { saveUpdateLcShippingMethod, getLcShippingMethodList } from "@/store/api";

const state = {
  lcShippingMethodList: [],
};

const getters = {
  getLcShippingMethodList(state) {
    return state.lcShippingMethodList;
  },
};

const mutations = {
  [SET_LC_SHIPPING_METHOD_LIST](state, data) {
    state.lcShippingMethodList = data;
  },
  [UNSET_LC_SHIPPING_METHOD_LIST](state) {
    state.lcShippingMethodList = [];
  },
};

const actions = {
  saveUpdateLcShippingMethod({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateLcShippingMethod, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        })
        .then((always) => {
          commit("UNSET_LOADING");
        });
    });
  },

  getLcShippingMethodList({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.get(getLcShippingMethodList, data)
        .then(function (response) {
          commit("SET_LC_SHIPPING_METHOD_LIST", response.data.data);
          resolve(response);
        })
        .catch(function (error) {
          commit("UNSET_LC_SHIPPING_METHOD_LIST");
          reject(error);
        })
        .then((always) => {
          commit("UNSET_LOADING");
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

